class MessageParams {
  constructor({
    id = `${Date.now()}`,
    nickname,
    text = '',
    date = `${Date.now()}`,
    type,
    subtype,
    authorId,
    modCount,
    lastEditedTime,
    translatedTextHtml,
    clientTimestamp = `${Date.now()}`,
    isFake = false,
    visitorServerUrl = window.visitorServerUrl,
    additionalState = { file: null, filename: null },
    /* eslint-disable-next-line no-shadow */
    textDisplayTemplate = ({ originalTextHtml }) => originalTextHtml,
  }) {
    this.id = id;
    this.nickname = nickname;
    this.text = textDisplayTemplate({ originalTextHtml: text, translatedTextHtml });
    this.originalText = text;
    this.date = date;
    this.type = type;
    this.subtype = subtype;
    this.authorId = authorId;
    this.modCount = modCount;
    this.lastEditedTime = lastEditedTime;
    this.translatedTextHtml = translatedTextHtml;
    this.clientTimestamp = clientTimestamp;
    this.isFake = isFake;
    this.visitorServerUrl = window.secure ? visitorServerUrl : visitorServerUrl.replace('https:', 'http:');
    this.additionalState = additionalState;
    this.textDisplayTemplate = textDisplayTemplate;
  }
}

export default MessageParams;
